import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { SESSION_KEYS } from "src/consts/session";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { Tariff } from "src/models/clientsModel";
import Text from "src/components/Displays/Text";

interface EconomyBoxProps {
  handleSubmit: () => void;
}

const EconomyBox = ({ handleSubmit }: EconomyBoxProps) => {
  const { t } = useTranslation();
  const [savingsYearly, setSavingsYearly] = useState("");

  const [getTarrifs] = useSessionStorage<Tariff[]>(SESSION_KEYS.TARIFFS);
  const tariffs = getTarrifs();

  useEffect(() => {
    if (tariffs && tariffs[0] && tariffs[0].savings) {
      setSavingsYearly(tariffs[0].savings.savingsYearly);
    }
  }, [tariffs]);

  return (
    <Stack
      gap={6}
      sx={(theme) => ({
        textAlign: "center",
        borderRadius: 2,
        px: 4,
        py: 2,
        backgroundColor: theme.palette.green[100],
      })}
    >
      <Stack
        sx={{
          gap: 2,
          textAlign: "center",
        }}
      >
        <Text
          text={t("page.calculatedSavings.great")}
          sx={{
            color: "#222",
            fontWeight: 295,
            fontSize: "24px",
            lineHeight: "27px",
            fontFamily: "isonType",
          }}
        />
        <Text
          text={t("page.calculatedSavings.potentialSavings")}
          sx={{
            color: "#222",
            fontWeight: 900,
            fontSize: "24px",
            lineHeight: "27px",
          }}
        />
        <Text
          text={t("page.calculatedSavings.potentialSavingsDescription")}
          sx={{
            color: "#222",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "24px",
          }}
        />
      </Stack>

      <Stack
        gap={2}
        direction={"row"}
        alignItems={"baseline"}
        justifyContent={"center"}
      >
        <Text
          text={`${savingsYearly} €`}
          sx={{
            color: "#009A22",
            fontWeight: 336,
            fontSize: "49px",
            lineHeight: "50px",
            fontFamily: "isonType",
          }}
        />

        <Text
          text={`/Jahr`}
          sx={{
            color: "#009A22",
            fontWeight: 700,
            fontSize: "20px",
            lineHeight: "50px",
            fontFamily: "isonType",
          }}
        />
      </Stack>

      <PrimaryButton
        text={t("page.calculatedSavings.tarif")}
        onClick={handleSubmit}
        sx={{
          mb: 3,
          textTransform: "none",
        }}
      />
    </Stack>
  );
};

export default EconomyBox;
